import React, { useEffect, useState } from 'react';

import { Toggle } from 'components/common';
import { createNotificationSettingsManager } from 'di';
import hidePhone from 'formatters/hidePhone';
import { useErrorCallback, useProfileData, useToggle } from 'hooks';
import { cn } from 'utils';

import styles from './NotificationsReceiveOptions.module.scss';

const NotificationsReceiveOptions = ({ modalActive }: { modalActive?: boolean }) => {
  const profileData = useProfileData();
  const [turning, setTurning] = useState(false);
  const handleError = useErrorCallback();
  const [phoneActive, togglePhone, setPhoneSettings] = useToggle();
  const [emailActive, toggleEmail, setEmailSettings] = useToggle();

  const getNotificationData = async () => {
    const manager = await createNotificationSettingsManager();
    const data = await manager.getNotifications();
    setPhoneSettings(data.smsSettings?.systemNotifications ?? false);
    setEmailSettings(data.mailSettings?.systemNotifications ?? false);
  };

  useEffect(() => {
    getNotificationData();
  }, []);

  const handleToggle = () => {
    (async () => {
      setTurning(true);
      try {
        const manager = await createNotificationSettingsManager();
        await manager.toggleSmsNotification(!phoneActive);
      } catch (error) {
        if (error instanceof Error) {
          await handleError(error);
        }
      } finally {
        setTurning(false);
      }
    })();
    togglePhone();
  };

  return (
    <div className={cn(styles.options, modalActive ? styles.inModal : styles.sidebar)}>
      <div className={styles.header}>
        <h2 className={styles.title}>Настройка</h2>
        <div className={styles.subtitle}>Дублировать уведомления</div>
      </div>

      <ul className={styles.list}>
        {profileData.email !== null && (
          <li className={styles.item}>
            <div className={styles.itemInfo}>
              <span className={styles.itemLabel}>На почту</span>
              <span className={styles.itemValue}>{profileData.email.email}</span>
            </div>
            <Toggle size="s" disabled={turning} active={emailActive} onToggled={toggleEmail} />
          </li>
        )}
        <li className={styles.item}>
          <div className={styles.itemInfo}>
            <span className={styles.itemLabel}>На номер телефона</span>
            <span className={styles.itemValue}>{hidePhone(profileData.phone)}</span>
          </div>
          <Toggle size="s" disabled={turning} active={phoneActive} onToggled={handleToggle} />
        </li>
      </ul>
    </div>
  );
};

export default NotificationsReceiveOptions;
